module.exports = __webpack_public_path__ + "img/Icon_awesome-facebook.d6ffd0dd.svg";